import ShimmerScreen from "../../../Layouts/ShimmerScreen"
import "./TitleLogoComponent.scss"

const TitleLogoComponent = ({logoURL, altText, isLoading}) => {
    return (
        <>
            {
                isLoading ?
                <div className="title-logo">
                    <ShimmerScreen
                        case="circle"
                        width="100%"
                        height="100%"
                    />
                </div>
                :
                logoURL ?
                <img className="title-logo" src={logoURL} alt={altText} />
                :
                <img className="title-logo" src='https://cdnstg.training.com/halifax/image/10543/2058509172-20241212.png' alt={altText} />
                // <div 
                //     className={`title-logo d-flex justify-content-center align-items-center bk-grey cursor-pointer`}
                // >
                //     <strong className="withoutimg" dangerouslySetInnerHTML={{
                //     __html: altText
                //     }}></strong>
                // </div>
            }
        </>
    )
}

export default TitleLogoComponent